'use strict'
import { request } from '../../plugins/http'

export default async (situation) => {
    return await request.post('/situacaoAtendimento', situation)
}